<script setup lang="ts">
import {onMounted, ref, type Ref, watch} from 'vue'
import {useRoute} from 'vue-router'
import {Icon} from '@iconify/vue'

import {getBatchById, getReturnedBatchById} from '@/api/batches'
import EditFinishedForm from '@/components/features/batches/forms/EditFinishedForm.vue'
import BatchActions from "@/components/features/batches/components/BatchActions.vue";

const route = useRoute()
const batchId = route.params.id as string

const batch: Ref<any | null> = ref(null)
const previousBatch: Ref<any | null> = ref(null)

const loading = ref(true)
const error = ref<string | null>(null)
ref(false);
const fetchBatch = async () => {
  loading.value = true
  error.value = null
  try {
    batch.value = await getReturnedBatchById(batchId)

    if (batch.value && batch.value.previousBatchId) {
      previousBatch.value = await getBatchById(batch.value.previousBatchId)
    }
  } catch (err) {
    error.value = 'Failed to fetch batch data. Please try again.'
  } finally {
    loading.value = false
  }
}

const formDisabled = ref(true)

onMounted(async () => {
  await fetchBatch()
})
</script>

<template>
  <div v-if="loading">Loading batch data...</div>

  <div v-else-if="error" class="text-red-500">{{ error }}</div>

  <div v-else class="p-10 bg-white rounded-xl">
    <div class="flex justify-between items-center mb-3">
      <RouterLink to="/batches" class="flex items-center gap-x-2 group hover:text-primary-default">
        <Icon
            icon="material-symbols:arrow-back-rounded"
            class="text-3xl group-hover:translate-x-2 transition-transform"
        />
        <span>Back</span>
      </RouterLink>

      <div class="flex-1 text-center">
        <h1 class="font-semibold text-2xl capitalize">Dispatched</h1>
      </div>
    </div>

    <BatchActions
        :batch-id="batchId"
        :is-returned-batch="true"
        :returned-batch-data="batch"
        :previous-batch-data="previousBatch"
    />
    <EditFinishedForm v-model="batch"  :disabled="formDisabled" type="view" parent="dispatched"/>
  </div>
</template>